import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  Output,
  Type,
  isDevMode,
} from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { NzModalService } from "ng-zorro-antd/modal";
import { ErrorCode, linkListingsDoc, PlatformInfo, PlatformType } from "@root/config";
import {
  AccountFormModalComponent,
  EditMode,
} from "@root/router/channel/account/account-form-modal/account-form-modal.component";
import { ModalRequestStatusComponent } from "@root/router/channel/account/modal-request-status/modal-request-status.component";
import { AccountService, SyncState } from "@root/router/channel/account/account.service";
import { IPartnerOperatorInfo, SystemService } from "@root/router/system/system.service";
import { ThreadService } from "@root/router/dialogue/chat-threads/thread.service";
import _ from "lodash";
import { Observable, Subject, takeUntil, tap } from "rxjs";
import { MemberService } from "@root/router/index/member.service";
import { WritePermissionGurd } from "@root/util/decorator";
import { TranslateService } from "@root/shared/service/translate.service";
import { AppService } from "@root/app.service";
import { V4ConnectWithAirbnbComponent } from "../v4/connect-with-airbnb/connect-with-airbnb.component";
import { V4ConnectSuccessComponent } from "../v4/connect-success/connect-success.component";
import { V4ConnectWithBookingComponent } from "../v4/connect-with-booking/connect-with-booking.component";
import { V4ConnectWithVrboComponent } from "../v4/connect-with-vrbo/connect-with-vrbo.component";
import { V4ConnectWithAgodaComponent } from "../v4/connect-with-agoda/connect-with-agoda.component";
import { V4ConnectWithXhsComponent } from "../v4/connect-with-xhs/connect-with-xhs.component";
import { V4ConnectWithDouyinComponent } from "../v4/connect-with-douyin/connect-with-douyin.component";
import { ModalService } from "@root/router/index/modal.service";
import { HttpClient } from "@angular/common/http";
import { NzMessageService } from "ng-zorro-antd/message";
import { V4ConnectWithCtripComponent } from "../v4/connect-with-ctrip/connect-with-ctrip.component";
import { SubscriptionService } from "@root/service";
import { V4ConnectWithGoogleComponent } from "../v4/connect-with-google/connect-with-google.component";
import { V4ConnectWithExpediaComponent } from "@root/router/channel/account/v4/connect-with-expedia/connect-with-expedia.component";
import { V4ConnectWithHoufyComponent } from "../v4/connect-with-houfy/connect-with-houfy.component";
import { V4SetPricingRatioComponent } from "../v4/set-pricing-ratio/set-pricing-ratio.component";
import { V4ConnectWithTongchengComponent } from "../v4/connect-with-tongcheng/connect-with-tongcheng.component";
import { V4HousesModalSelectComponent } from "@root/router/component/v4/houses-modal-select/houses-modal-select.component";
import { V4RoomTypesModalSelectComponent } from "@root/router/component/v4/room-types-modal-select/room-types-modal-select.component";

@Component({
  selector: "host-base-account-list",
  templateUrl: "./base-account-list.component.html",
  styleUrls: ["./base-account-list.component.scss"],
})
export class BaseAccountListComponent implements AfterViewInit, OnDestroy {
  readonly Platform: typeof PlatformType = PlatformType;
  @Output() onConnect = new EventEmitter();

  listOfAccount = [];
  page = 1;
  pageSize = 20;
  total = 0;
  optionsOfChannel = [];
  isAirbnbRelogin = false; // 爱彼迎重新登录特殊处理..
  airbnbReloginUsername;
  airbnbReloginId;
  // headerList = HeaderListForAccount;
  loading = false;
  pageLoading = false;
  airbnbInfo = PlatformInfo[PlatformType.Airbnb];
  searchForm: UntypedFormGroup = this.fb.group({
    username: null,
    thirdparty_type: null,
  });

  searching = false;

  private displayModal$ = this.accountService.displayModal$.pipe(
    tap((value) => {
      console.log("displayModal$", value);

      const { type, data } = value;
      if (type === "create") {
        this.onClickCreateAccount(data.thirdpartyType);
      } else if (type === "re-login") {
        this.displayAccountFormModal(data, EditMode.Update);
      } else if (type === "loading") {
        this.displayLoginLoadingModal(data.data, data.thirdpartyType);
      }
    }),
  );
  private syncStatusChange$ = this.accountService.syncStateChange$.pipe(
    tap((value: SyncState) => {
      if (value === SyncState.Complete) {
        this.fetchAccountList(false);
      }
    }),
  );

  private syncAccountStateChange$ = this.accountService.accountSyncStateChange$.pipe(
    tap((value) => {
      this.fetchAccountList(false);
      // if (value.state === SyncState.Complete) {
      //   this.refreshAccountListV2();
      // } else {
      //   const data = value.data;
      //   this.updateSyncState(data.ratio, data.account_id);
      // }
    }),
  );
  private isPartnerOperator: IPartnerOperatorInfo = {
    is_partner_operator: null,
  };
  private partnerOperatorInfoChange$ = this.systemService.partnerOperatorInfoRaw$.pipe(
    tap((value) => (this.isPartnerOperator = value)),
  );
  private destroy$ = new Subject();

  constructor(
    public fb: UntypedFormBuilder,
    private activatedRoute: ActivatedRoute,
    private threadService: ThreadService,
    private modal: NzModalService,
    private msg: NzMessageService,
    private globalModal: ModalService,
    private accountService: AccountService,
    private systemService: SystemService,
    private router: Router,
    private member: MemberService,
    private subscription: SubscriptionService,
    private t: TranslateService,
    private cdr: ChangeDetectorRef,
    private app: AppService,
    private http: HttpClient,
  ) {
    this.pageLoading = true;

    this.fetchOptionsOfChannel();
    this.fetchAccountList();

    this.syncStatusChange$.pipe(takeUntil(this.destroy$)).subscribe();
    this.syncAccountStateChange$.pipe(takeUntil(this.destroy$)).subscribe();
    this.displayModal$.pipe(takeUntil(this.destroy$)).subscribe();
    this.partnerOperatorInfoChange$.pipe(takeUntil(this.destroy$)).subscribe();
  }

  get isInternational() {
    return this.app.app.international;
  }

  get linkListingsDoc() {
    return linkListingsDoc(this.isInternational);
  }

  ngAfterViewInit() {
    this.subscribeQueryParam();
    this.subscribeFormChange();

    if (isDevMode()) {
      // this.displayConnectWithXHSModal();
      // this.displayConnectWithHoufyModal();
    }
    // this.displayConnectWithGoogleVRModal();
  }

  subscribeQueryParam() {
    this.activatedRoute.queryParams.subscribe((res) => {
      console.log("res: ", res);

      const { success, error, thirdparty_type, error_code, token } = res;
      // const success = res.get('success');
      // const error = res.get('error');
      // const thirdparty_type = res.get('thirdparty_type');

      // if (success || error) {
      //   alert(success ? success : error);
      // }
      if (thirdparty_type && success) {
        this.displayV4SetPricingRatioModal(+thirdparty_type);
        // this.displayConnectSuccessModal(thirdparty_type);
      }

      if (+error_code === ErrorCode.AccountOccupied) {
        this.accountService.displayAccountOccupiedWarning(token);
      }

      if (error) {
        alert(error);
      }

      if (success || error) {
        this.router.navigate(["app/connected-accounts"], {
          queryParams: {
            success: null,
            thirdparty_type: null,
          },
        });
      }
    });
  }

  subscribeFormChange() {
    this.searchForm.valueChanges.subscribe((rst) => {
      this.page = 1;
      this.searching = true;
      this.fetchAccountList();
    });
  }

  onPageChange(page) {
    this.page = page;
    this.fetchAccountList();
  }

  @WritePermissionGurd("thirdparty")
  onClickCreateAccount(thirdpartyType) {
    this.onConnect.emit({ thirdparty_type: thirdpartyType });
    this.modal.closeAll();

    if (this.isInternational) {
      if (this.subscription.isStandardEdition && thirdpartyType === PlatformType.Vrbo) {
        this.subscription.displayVrboConnectForbiddenWarning();
        return;
      }
    } else {
      if (this.member.isFreeEditionForbiddenChannel(thirdpartyType)) {
        this.member.freeEditionLinkChannelLimitWarning();
        return;
      }

      if (this.member.isEditionExpiredOrExceed() && !this.isPartnerOperator) {
        this.member.editionExpiredOrExceedWarning();
        return;
      }
    }

    switch (thirdpartyType) {
      case PlatformType.MeiTuanMinSu:
      case PlatformType.XiaoZhu:
      case PlatformType.TuJiaIntl:
      case PlatformType.TuJia:
        this.toThirdAuthPage(thirdpartyType);
        break;
      case PlatformType.Airbnb:
        this.displayConnectWithAirbnbModal();
        break;
      case PlatformType.Booking:
        this.displayConnectWithBookingModal();
        break;
      case PlatformType.Agoda:
        this.displayConnectWithAgodaModal();
        break;
      case PlatformType.Vrbo:
        this.displayConnectWithVrboModal();
        break;
      case PlatformType.XHS: {
        this.checkXhsLinkLimit().subscribe(() => {
          this.displayConnectWithXHSModal();
        });
        break;
      }
      // case PlatformType.Douyin:
      //   this.displayConnectWithDouyinModal();
      //   break;
      case PlatformType.CtripOffical:
        this.displayConnectWithCtripModal();
        break;
      case PlatformType.GoogleVR:
        this.displayConnectWithGoogleVRModal();
        break;
      case PlatformType.Expedia:
        this.displayConnectWithExpediaModal();
        break;
      case PlatformType.Houfy:
        this.displayConnectWithHoufyModal();
        break;
      case PlatformType.TongCheng:
        this.displayConnectWithTongchengModal();
        break;
      default:
        this.displayAccountFormModal({ thirdpartyType }, EditMode.Create);
    }
  }

  onClickReconnect(data) {
    const { thirdparty_type: thirdpartyType, username, id: accountId } = data;
    if (this.member.isFreeEditionForbiddenChannel(thirdpartyType)) {
      this.member.freeEditionLinkChannelLimitWarning();
      return;
    }
    if (this.member.isEditionExpiredOrExceed() && !this.isPartnerOperator) {
      this.member.editionExpiredOrExceedWarning();
      return;
    }
    switch (thirdpartyType) {
      case PlatformType.Airbnb:
      case PlatformType.MeiTuanMinSu:
      case PlatformType.XiaoZhu:
      case PlatformType.TuJiaIntl:
      case PlatformType.TuJia:
        this.toThirdAuthPage(thirdpartyType);
        break;
      case PlatformType.Booking:
        this.displayConnectWithBookingModal();
        break;
      case PlatformType.Agoda:
        this.displayConnectWithAgodaModal();
        break;
      case PlatformType.CtripOffical:
        this.displayConnectWithCtripModal();
        break;
      case PlatformType.XHS: {
        this.msg.warning("请联系客服");
        break;
      }
      case PlatformType.Expedia:
        this.displayConnectWithExpediaModal();
        break;
      case PlatformType.Houfy:
        this.displayConnectWithHoufyModal();
        break;
      case PlatformType.TongCheng:
        this.displayConnectWithTongchengModal();
        break;
      default:
        this.displayAccountFormModal(
          {
            thirdpartyType,
            username,
            accountId,
          },
          EditMode.Update,
        );
    }
  }

  onClickDeleteAccount(id) {
    this.displayDeleteAccountWarning().subscribe(() => {
      this.requestDeleteAccount(id);
    });
  }

  onClickChangePassword(data) {
    console.log("change password:", data);
    const { thirdparty_type: thirdpartyType, username, id: accountId } = data;
    this.displayAccountFormModal(
      {
        thirdpartyType,
        username,
        accountId,
      },
      EditMode.Update,
    );
  }

  onClickChangeCtripUsername(data) {
    this.displayConnectWithCtripModal({
      thirdpartyAccount: data.id,
    });
  }

  onClickTongchengAddProperties(data) {
    const { thirdparty_account_id, type } = data;
    const cmp: Type<any> = type === "house" ? V4HousesModalSelectComponent : V4RoomTypesModalSelectComponent;
    const modal = this.modal.create({
      // nzTitle: '添加房源',
      nzTitle: this.t.t("thirdhub.pricelabs.operate.btn.add"),
      nzContent: cmp,
      nzWidth: 900,
      nzFooter: null,
    });
    modal.afterClose.subscribe(({ data }) => {
      console.log("after close: ", data);
      if (data) {
        const ids = data?.map((t) => t.value) ?? [];
        if (type === "house") {
          this.requestCreateProperties({ thirdparty_account_id, property_ids: ids });
        } else {
          this.requestCreateProperties({ thirdparty_account_id, room_type_ids: ids });
        }
      }
    });
  }

  private requestCreateProperties(data: {
    thirdparty_account_id: string;
    property_ids?: number[];
    room_type_ids?: number[];
  }) {
    const params = {
      ...data,
    };
    this.http.post("/api/tongcheng/add_listings", params).subscribe((rst: any) => {
      if (isDevMode() || rst.error_code === 0) {
        this.fetchAccountList();
      }
    });
  }

  /**
   * 跳转第三方授权页面
   * 爱彼迎，榛果，小猪目前直连需要跳转第三方授权页面
   */
  @WritePermissionGurd("thirdparty")
  toThirdAuthPage(thirdparty: PlatformType) {
    const urlMap = {
      [PlatformType.Airbnb]: "airbnb",
      [PlatformType.XiaoZhu]: "xiaozhu",
      [PlatformType.MeiTuanMinSu]: "zhenguo",
      [PlatformType.TuJiaIntl]: "tujia_intl",
      [PlatformType.TuJia]: "tujia",
    };
    const url = this.systemService.oauthUrl[urlMap[thirdparty]];
    window.open(url);
  }

  @WritePermissionGurd("thirdparty")
  syncAccountHouse(data) {
    // if (!this.hasWritePermission()) {
    //   this.modalService.warning({
    //     nzTitle: "暂无修改权限，请联系管理员"
    //   });
    //   return;
    // }
    if (this.member.isEditionExpiredOrExceed() && !this.isPartnerOperator) {
      this.member.editionExpiredOrExceedWarning();
      return;
    }

    const { id, read_house } = data;

    if (read_house) {
      return;
    }

    this.accountService.syncAccountHouse({ thirdparty_account_id: id }).subscribe();
    this.fetchAccountList(false);
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  private fetchAccountList(loading = true) {
    const form = this.searchForm.value;
    const p = {
      page: this.page,
      page_size: this.pageSize,
      ...form,
    };
    this.loading = loading;
    this.accountService.getAccountListV2(p).subscribe((res) => {
      this.pageLoading = false;
      this.loading = false;
      this.listOfAccount = _.get(res, "data.list", []);
      this.total = _.get(res, "data.total", 0);
      this.cdr.detectChanges();
    });
  }

  private fetchOptionsOfChannel() {
    this.threadService.getHouseThirdpartyList().subscribe((res) => {
      const list = _.get(res, "data.had_thirdparty") || [];
      this.optionsOfChannel = _.map(list, (type) => ({
        label: this.t.t("word.channel_" + type),
        value: type,
        type,
        name: _.get(PlatformInfo[type], "name"),
      }));
      this.optionsOfChannel.unshift({
        label: this.t.t("word.any"),
        value: null,
      });
    });
  }

  private requestDeleteAccount(id) {
    this.accountService.deleteAccount({ id }).subscribe((res) => {
      if (res.error_code === 0) {
        this.fetchAccountList();
      }
    });
  }

  private checkXhsLinkLimit() {
    return new Observable((observer) => {
      this.http.get("/api/thirdparty/xiaohongshu_info").subscribe((rst: HttpRsp) => {
        const hasXhs = rst?.data?.has_xhs;
        // const hasXhs = false;
        if (hasXhs) {
          this.msg.warning("您只能绑定一个小红书账号。");
        } else {
          observer.next(null);
        }
        observer.complete();
      });
    });
  }

  private displayTestFeatureWaning(thirdpartyType) {
    const name = PlatformInfo[thirdpartyType]?.name;
    this.modal.warning({
      nzTitle: `申请${name}直连内测`,
      nzContent: `${name}直连内测已经开启，您可以联系客服申请内测名额。内测结束后将正式开放。`,
      nzOkText: "知道了",
    });
  }

  /**
   * 创建/更新账号modal
   * 仅仅用于账号密码创建的账号，官方直连渠道走第三方的授权页面，无需使用此种方式
   */
  private displayAccountFormModal(
    data: {
      thirdpartyType: PlatformType;
      accountId?: number;
      username?: string;
    },
    mode: EditMode = EditMode.Create,
  ) {
    this.modal.create({
      nzContent: AccountFormModalComponent,
      nzWidth: 412,
      nzFooter: null,
      nzMaskClosable: false,
      nzData: {
        ...data,
        editMode: mode,
      },
      // nzComponentParams: {
      //   ...data,
      //   editMode: mode,
      // },
      nzOnOk: () => {
        this.fetchAccountList();
      },
    });
  }

  // @WritePermissionGurd("thirdparty")
  private displayDeleteAccountWarning() {
    console.log("display delete account warning ");
    return new Observable((observer) => {
      const modal = this.modal.confirm({
        // nzTitle: "<b>确定要删除渠道账号吗？</b>",
        nzTitle: this.translate("warning.confirm_delete_channel_account"),
        nzContent: this.translate("warning.after_delete_channel_account_info"),
        // nzContent:
        //   "删除渠道账号之后，您的房间仍然存在，不会影响房态、订单、统计等数据。但该账号的房源以及房源和房间的关联关系将全部删除。",
        nzOkText: this.translate("word.confirm"),
        nzCancelText: this.translate("word.cancel"),
        nzOnOk: () => {
          observer.next(null);
          // observer.complete();
        },
        nzOnCancel: () => {
          // observer.complete();
        },
      });
      modal.afterClose.subscribe(() => {
        observer.complete();
      });
    });
  }

  private displayV4ConnectModal(component: any, platformType: PlatformType, payload?: any) {
    const modal = this.modal.create({
      nzTitle: null,
      nzContent: component,
      nzMask: false,
      nzZIndex: 999,
      nzFooter: null,
      nzWidth: 800,
      nzData: { ...payload },
    });
    modal.afterClose.subscribe((rst) => {
      if (rst === "success") {
        this.displayV4SetPricingRatioModal(platformType);
        // this.displayConnectSuccessModal(platformType);
      }
      if (rst === "contact") {
        this.globalModal.displayCustomerServiceClient();
      }
      this.fetchAccountList();
    });

    return modal;
  }

  private displayV4SetPricingRatioModal(platform: PlatformType) {
    const modal = this.modal.create({
      nzTitle: null,
      nzContent: V4SetPricingRatioComponent,
      nzWidth: 600,
      nzFooter: null,
      nzData: { thirdpartyType: platform },
    });
    modal.afterClose.subscribe((rst) => {
      if (rst === "success") {
        this.displayConnectSuccessModal(platform);
      }
    });
  }

  private displayConnectSuccessModal(thirdparty_type) {
    const modal = this.modal.create({
      nzTitle: null,
      // nzContent: AirbnbAuthSuccessComponent,
      nzContent: V4ConnectSuccessComponent,
      nzFooter: null,
      nzWidth: 800,
      nzData: {
        thirdpartyType: thirdparty_type,
      },
      // nzComponentParams: {
      //   thirdpartyType: thirdparty_type,
      // },
    });
    modal.afterClose.subscribe((rst) => {
      this.fetchAccountList();
    });
  }

  private displayConnectWithAirbnbModal() {
    this.displayV4ConnectModal(V4ConnectWithAirbnbComponent, PlatformType.Airbnb);
  }

  private displayConnectWithBookingModal() {
    this.displayV4ConnectModal(V4ConnectWithBookingComponent, PlatformType.Booking);
  }

  private displayConnectWithAgodaModal() {
    this.displayV4ConnectModal(V4ConnectWithAgodaComponent, PlatformType.Agoda);
  }

  private displayConnectWithVrboModal() {
    this.displayV4ConnectModal(V4ConnectWithVrboComponent, PlatformType.Vrbo);
  }

  private displayConnectWithXHSModal() {
    this.displayV4ConnectModal(V4ConnectWithXhsComponent, PlatformType.XHS);
  }

  private displayConnectWithDouyinModal() {
    this.displayV4ConnectModal(V4ConnectWithDouyinComponent, PlatformType.Douyin);
  }

  private displayConnectWithCtripModal(payload?) {
    this.displayV4ConnectModal(V4ConnectWithCtripComponent, PlatformType.CtripOffical, payload);
  }

  private displayConnectWithGoogleVRModal() {
    this.displayV4ConnectModal(V4ConnectWithGoogleComponent, PlatformType.GoogleVR);
  }

  private displayConnectWithExpediaModal() {
    this.displayV4ConnectModal(V4ConnectWithExpediaComponent, PlatformType.Expedia);
  }

  private displayConnectWithHoufyModal() {
    this.displayV4ConnectModal(V4ConnectWithHoufyComponent, PlatformType.Houfy);
  }

  private displayConnectWithTongchengModal() {
    this.displayV4ConnectModal(V4ConnectWithTongchengComponent, PlatformType.TongCheng);
  }

  /** 登录状态 */
  private displayLoginLoadingModal(data, thirdpartyType) {
    const id = data.id;
    const tujia = data.tujia;
    const muniao = data.muniao;
    const username = data.username;
    const modal = this.modal.create({
      nzFooter: null,
      nzContent: ModalRequestStatusComponent,
      nzMaskClosable: false,
      nzClosable: true,
      nzComponentParams: {
        thirdpartyType,
        ...data,
        // id,
        // thirdpartyType,
        // username,
        // tujia,
        // muniao,
      },
    });
    modal.afterClose.subscribe((res) => {
      this.fetchAccountList();
      this.systemService.initMsgCount();
    });
  }

  private translate(key, params?) {
    return this.t.t(key, params);
  }
}
